import type { CoreApiClient } from "../client";
import type { FullAirHandlerUnit, UpdateAirHandlerUnitRequestBody } from "../types/air-handler-unit.type";

export const createAirHandlerUnitMutations = (api: CoreApiClient) => {
  const { request } = api;

  /**
   * Writable CTA fields: actuator commands (command/forcing, fans/dampers/coils…), setpoints,
   * free cooling and metadata (name/group/floor position). Group edits fan this out per unit.
   */
  const update = async (
    buildingId: string,
    airHandlerUnitId: string,
    body: UpdateAirHandlerUnitRequestBody,
  ): Promise<FullAirHandlerUnit> => {
    const { data } = await request("patch", "/buildings/{buildingId}/air-handler-units/{airHandlerUnitId}", {
      params: { path: { buildingId, airHandlerUnitId } },
      body,
    });
    return data;
  };

  return {
    update,
  };
};
